import type { AdminApiOrganizationUser } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminOrganizationUsersResponse =
  | AdminApiOrganizationUser[]
  | {
      data?: AdminApiOrganizationUser[];
    };

const normalizeOrganizationUsers = (
  payload: AdminOrganizationUsersResponse
): AdminApiOrganizationUser[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminOrganizationStaffs(organizationId: number) {
  return useQuery({
    queryKey: ['admin', 'organization-users', organizationId],
    queryFn: async () => {
      const response = await fetch(
        `/admin/api/organization_users?organization_id=${organizationId}`
      );
      if (!response.ok) {
        throw new Error('スタッフ一覧の取得に失敗しました');
      }
      const data: AdminOrganizationUsersResponse = await response.json();
      return normalizeOrganizationUsers(data);
    },
  });
}
